'use client';
import { useRouter } from 'next/navigation';

import Image from 'next/image';

import UserInitialsAvatar from '@/components/userInitialsAva';
import { useEntityImageStore } from '@/hooks/useEntityImage';
import type { CustomerReviewResponse } from '@/types/apps/customer-review.type';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';

interface Props {
    item: CustomerReviewResponse;
}

export const RatingItemEntity: React.FC<Props> = ({ item }) => {
    const router = useRouter();
    const { url } = useEntityImageStore('Customer', item.id);

    return (
        <div className='flex justify-between items-center w-full border-b py-3 cursor-pointer '>
            <div className='flex items-center w-[50%]'>
                {url ? (
                    <Image
                        src={url}
                        alt={item?.customer?.name || 'avatar'}
                        width={38}
                        height={38}
                        className='rounded-full object-cover'
                    />
                ) : (
                    <UserInitialsAvatar
                        name={item?.customer?.name}
                        initialsCount={2}
                        width={38}
                        height={38}
                    />
                )}
                <div className='flex flex-col pl-4 w-full'>
                    <p className='font-semibold text-base'>
                        {item.customer?.name || 'N/A'}
                    </p>
                    <p className='text-sm text-[#3A3541AD]'>
                        {t('Ngày đánh giá')}:{' '}
                        {dateUtils.getDate(item?.createdDate)}
                    </p>
                    <p className='text-sm text-[#3A3541AD]'>
                        {item?.taskCheck?.code
                            ? `${t('Mã Task')}: ${item?.taskCheck?.code}`
                            : `${t('Mã Ticket')}: ${item?.ticket?.code}`}
                    </p>
                </div>
            </div>
            <div className='flex flex-col items-end text-right gap-[6px] w-[50%]'>
                <div className='flex items-center gap-[6px]'>
                    <p className='text-base font-medium'>{item.rating}</p>
                    <Stack spacing={1}>
                        <Rating
                            value={Number(item.rating)}
                            readOnly
                            precision={0.5}
                        />
                    </Stack>
                </div>
                <p className='text-sm text-[#3A3541AD]'>
                    {item.comment || '-:-'}
                </p>
            </div>
        </div>
    );
};
